//@ts-check

/**
 * Array of `[name, code]` tuples
 */
export const facias = [
    ['JD Sports', 'jd'],
    ['Size?', 'sz'],
    ['Footpatrol', 'fp'],
    ['Tessuti', 'te'],
    ['Millets', 'ml'],
    ['Blacks', 'bl'],
    ['Ultimate Outdoors', 'uo'],
    ['First Sports', 'fs'],
];

export const faciaNames = facias.map(([name, code]) => name);
export const faciaCodes = facias.map(([name, code]) => code);

export const getFaciaCode = (faciaName) => {
    const facia = facias.find(([name, code]) => name === faciaName) || [];
    return facia[1];
};

export const getFaciaName = (faciaCode) => {
    const facia = facias.find(([name, code]) => code === faciaCode) || [];
    return facia[0];
};
